<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wyrejestrowania'" [name]="'Lista'"></app-breadcrumb>
<div class="deregistration-pack-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <app-dict-insurance-companies
      [multiple]="false" label="TU"
      class="deregistration-pack-filter"
      [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="false" label="Status"
      class="deregistration-pack-filter"
      dictType="deregistration_pack_status"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict
      [multiple]="false" label="Firma"
      class="deregistration-pack-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-datepicker
      class="deregistration-pack-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="deregistration-pack-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="deregistration-pack-filter"
      label="Data wysłania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$sentAt" name="gte$sentAt"
    ></app-datepicker>

    <app-datepicker
      class="deregistration-pack-filter"
      label="Data wysłania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$sentAt" name="lte$sentAt"
    ></app-datepicker>

  </form>

  <div class="deregistration-pack-buttons"    fxLayout="row" fxLayoutAlign="space-between">
    <div >
      <button  [disabled]="!(userPermissions | async).deregistration.delete" *ngIf="!protocolOpened"  mat-raised-button color="primary" (click)="openProtocol()" ><mat-icon>send</mat-icon>  Generuj dokumenty </button>
      <button  [disabled]="!(userPermissions | async).deregistration.delete" *ngIf="protocolOpened" mat-raised-button color="primary" (click)="generateDataDocuments()"><mat-icon>send_and_archive</mat-icon>  Generuj</button>
      <button  [disabled]="!(userPermissions | async).deregistration.delete" *ngIf="protocolOpened" (click)="cancel()" mat-raised-button color="warn"><mat-icon>cancel_schedule_send</mat-icon> <span>  Anuluj</span></button>

    </div>
    <div>
      <button *ngIf="(userPermissions | async).deregistration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).deregistration.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="deregistrationPacks">

    <ng-container matColumnDef="select"  >
      <th mat-header-cell *matHeaderCellDef>

      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          *ngIf="this.protocolOpened && row.status.key===DEREGISTRATION_PACK_STATUS_NEW"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="isSelect(row.uuid)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyrejestrowania/szczegoly', element.uuid]">{{element.insuranceCompany.name}} {{element.createdAt | date:'y-MM-dd'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="sentAt">
      <th mat-header-cell *matHeaderCellDef> Data wysłania </th>
      <td mat-cell *matCellDef="let element">
        {{element.sentAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="registrationsCount">
      <th mat-header-cell *matHeaderCellDef> Liczba rejestracji </th>
      <td mat-cell *matCellDef="let element">
        {{element.registrationsCount}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button *ngIf="(userPermissions | async).deregistration.delete" [disabled]="!(userPermissions | async).deregistration.delete" mat-menu-item (click)="delete(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
